import styled from "styled-components";

export const LoadingStyled = styled.div`
	height: 100%;
	width: 100%;

	display: flex;
	justify-content: center;
	align-items: center;
	img {
		width: 150px;
		animation: is-rotating 2.3s infinite;
	}

	@keyframes is-rotating {
		to {
			transform: rotate(-1turn);
		}
	}
`;
